const SELECT_REQUEST = 'report-templates/select/request'
const SELECT_SUCCESS = 'report-templates/select/success'
const SELECT_FAILURE = 'report-templates/select/failure'

export { SELECT_REQUEST, SELECT_SUCCESS, SELECT_FAILURE }
